import { render, staticRenderFns } from "./inventoryWebhook.vue?vue&type=template&id=2b285428&scoped=true"
import script from "./inventoryWebhook.vue?vue&type=script&lang=js"
export * from "./inventoryWebhook.vue?vue&type=script&lang=js"
import style0 from "./inventoryWebhook.vue?vue&type=style&index=0&id=2b285428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b285428",
  null
  
)

export default component.exports